<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="3"></b-col>
              <b-col md="2" class="my-1">
                <b-row>
                  <b-col sm="6">
                    <b-form-select v-model="perPage" :options="pageOptions"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="12">
                <b-table striped hover :fields="fieldItems" :items="items" :busy="items == 0" :current-page="currentPage" :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>

                  <template slot="top_yn" slot-scope="data">
                    <div>
                      <c-switch type="text" :id="'topSelect'+data.item.rnum" variant="primary" v-model="data.item.top_yn"  v-on:change="NoticeTopYN(data.item)" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                    </div>
                  </template>

                  <template slot="subject" slot-scope="data">
                    <div><a href="javascript:void(0)" v-on:click="noticeInfoGo(data.item)">{{data.item.subject}}</a></div>
                  </template>

                </b-table>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="12" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage" align="center"/>
              </b-col>
            </b-row>
          </b-col>

        </b-row>

        <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/manager/noticeform/form?status=insert'">
            <i class="fa fa-hand-o-up"/> 신규등록
          </b-button>
        </div>

      </b-card>
    </b-col>
  </b-row>
</template>
<script>


import cSwitch from '../../../components/Switch'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { EventBus } from "../../event-bus";
const moment = require("moment");

export default {
  name: 'NoticeList',
  props: {
    queryParams: {
      type: Object
    },
    fieldItems: {
      type: Array
    },
    fullDate: {
      type: Array
    },
  },

  components: {
    PulseLoader,
    cSwitch
  },
  created() {
    // 이벤트 버스 선언
    EventBus.$on("callFindNotice", () => {
      this.findDrNoticeList();
    });
  },
  data () {
    return {
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      items: [],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  mounted() {
    this.findDrNoticeList();
  },
  methods: {

    NoticeTopYN(data) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var item = data;
      var newActive = item.top_yn;

      self.$http.get('/api/update/noticeTopYn?access_token='+token + '&mn_notice_code='+item.mn_notice_code + '&top_yn='+newActive)
        .then((result) => {
          self.findDrNoticeList();
        })
    },

    findDrNoticeList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");

      self.queryParams.start_date = this.$parent.getFormatDate(this.fullDate[0]);
      self.queryParams.end_date = this.$parent.getFormatDate(this.fullDate[1]);

      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/noticeManagementList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          var itemCnt = self.items.length;
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
            el.selectchecked = false;

          });
        })
    },

    noticeInfoGo (row) {
      var self = this;
      var url = '#/manager/noticeform/form?status=update';
      self.$session.set('mn_notice_code', row.mn_notice_code);
      location.href = url;
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/views/notice/component/NoticeList.vue